import {
    validateAdviser,
    validateAppointmentType,
    validateDate,
    validateEndTime,
    validateLocation,
    validateParticipant,
    validateRemoteCallUrl,
    validateService,
    validateStartTime
} from './validationFunctions';

export const validateAppointment = (newEntry) => {
    let newErrors = {};
    newErrors = validateService(newEntry.serviceId, newErrors);
    newErrors = validateAdviser(newEntry.userId, newErrors);
    newErrors = validateAppointmentType(newEntry.typeId, newErrors);
    newErrors = validateLocation(newEntry.locationId, newErrors);
    if (newEntry.remoteCallUrl)
        newErrors = validateRemoteCallUrl(newEntry.remoteCallUrl, newErrors);
    newErrors = validateStartTime(newEntry.startTime, newEntry.endTime, newErrors);
    newErrors = validateEndTime(newEntry.endTime, newEntry.startTime, newErrors);
    newErrors = validateDate(newEntry.date, newErrors);
    newErrors = validateParticipant(newEntry.participantId, newErrors);

    return newErrors;
};
